var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataMaintenanceFlatline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "data-maintenance-flatline",
    imageName: "Data Maintenance",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_158_data_maintenance_flatline",
    "data-name": "#158_data_maintenance_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.53,215.45a.51.51,0,0,1-.5-.44.51.51,0,0,1,.44-.56s3.88-.64,5.89-9.64c2.15-9.61.13-116.08-.5-121.22-.55-4.5-9.2-4.56-9.29-4.56a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5c.39,0,9.63.06,10.28,5.44.63,5.15,2.64,111.91.48,121.56s-6.56,10.4-6.74,10.42Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.37,132.57c-.1,0-.17-.07-.27-.15-.38-.32-.06-.71.09-.9a.53.53,0,0,1,.14-.12l2.06-2.39c2.91-3.39,2.66-41.13,1.63-48.4-.61-4.26-1.85-5.77-2.78-6.29a1.92,1.92,0,0,0-1.56-.18.5.5,0,0,1-.4-.92,2.9,2.9,0,0,1,2.45.23c1.64.91,2.74,3.28,3.28,7,.81,5.7,1.62,45.13-1.86,49.19-1.13,1.32-1.78,2.08-2.18,2.49h0s-.09.11-.12.16l0,0C201.6,132.49,201.47,132.57,201.37,132.57Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58,170.72a.5.5,0,0,1-.06-1c.2,0,4.94-.59,6.63-6.31,1.77-6,1.76-46.54,0-64.7-.42-4.26-1.62-7-3.48-7.94a4.46,4.46,0,0,0-3.91.24.51.51,0,0,1-.69-.18.49.49,0,0,1,.17-.68,5.42,5.42,0,0,1,4.88-.27c2.21,1.11,3.56,4.05,4,8.73,1.79,18.23,1.78,59,0,65.08a9.42,9.42,0,0,1-7.47,7Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.52,238.81l-.11,0c-.55-.13-55.24-12.76-81.61-8.06-27.21,4.84-39.85,5.9-47.72-.1-7.35-5.6-13.48-2.64-13.74-2.52a.49.49,0,0,1-.67-.22.5.5,0,0,1,.22-.67c.28-.14,6.94-3.37,14.8,2.62,7.52,5.73,20.56,4.6,46.93-.1,26.58-4.73,81.46,7.95,82,8.08a.5.5,0,0,1,.37.6A.5.5,0,0,1,342.52,238.81Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.52,242.88h-285a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h285a.5.5,0,0,1,.5.5A.5.5,0,0,1,342.52,242.88Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.3,
    y: 52.74,
    width: 118.82,
    height: 185.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.12,238.81H80.3a.5.5,0,0,1-.5-.5V52.75a.5.5,0,0,1,.5-.5H199.12a.5.5,0,0,1,.5.5V238.31A.5.5,0,0,1,199.12,238.81Zm-118.32-1H198.62V53.25H80.8Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.37,
    y: 70.05,
    width: 96.69,
    height: 20.06,
    transform: "translate(279.42 160.16) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,90.61H91.37a.5.5,0,0,1-.5-.5V70.05a.5.5,0,0,1,.5-.5h96.68a.5.5,0,0,1,.5.5V90.11A.5.5,0,0,1,188.05,90.61Zm-96.18-1h95.68V70.55H91.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,76.89h-2.52a.5.5,0,0,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,84.27h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,84.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,76.89h-2.52a.5.5,0,0,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,84.27h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,84.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,76.89h-2.52a.5.5,0,0,1,0-1H156a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,84.27h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,84.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,76.89h-2.53a.5.5,0,0,1,0-1h2.53a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,84.27h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,164.17,84.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,76.89h-2.53a.5.5,0,0,1,0-1h2.53a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,84.27h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,172.32,84.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,76.89H178a.5.5,0,0,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,84.27H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,84.27Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 76.39,
    width: 30.35,
    height: 7.38,
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,84.27H97.3a.5.5,0,0,1-.5-.5V76.39a.5.5,0,0,1,.5-.5h30.35a.5.5,0,0,1,.5.5v7.38A.5.5,0,0,1,127.65,84.27Zm-29.85-1h29.35V76.89H97.8Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.83,
    cy: 80.16,
    r: 1.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.75,
    cy: 80.16,
    r: 1.92,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.37,
    y: 95.07,
    width: 96.69,
    height: 20.06,
    transform: "translate(279.42 210.21) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,115.64H91.37a.5.5,0,0,1-.5-.5V95.07a.5.5,0,0,1,.5-.5h96.68a.5.5,0,0,1,.5.5v20.07A.5.5,0,0,1,188.05,115.64Zm-96.18-1h95.68V95.57H91.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,101.91h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,101.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,109.3h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,109.3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,101.91h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,101.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,109.3h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,109.3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,101.91h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,101.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,109.3h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,109.3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,101.91h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,164.17,101.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,109.3h-2.53a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.53a.5.5,0,0,1,.5.5A.51.51,0,0,1,164.17,109.3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,101.91h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,172.32,101.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,109.3h-2.53a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.53a.5.5,0,0,1,.5.5A.51.51,0,0,1,172.32,109.3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,101.91H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,101.91Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,109.3H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,109.3Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 101.41,
    width: 30.35,
    height: 7.38,
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,109.3H97.3a.5.5,0,0,1-.5-.5v-7.39a.5.5,0,0,1,.5-.5h30.35a.5.5,0,0,1,.5.5v7.39A.5.5,0,0,1,127.65,109.3Zm-29.85-1h29.35v-6.39H97.8Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.83,
    cy: 105.19,
    r: 1.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.75,
    cy: 105.19,
    r: 1.92,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.37,
    y: 120.1,
    width: 96.69,
    height: 20.06,
    transform: "translate(279.42 260.26) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,140.66H91.37a.5.5,0,0,1-.5-.5V120.1a.5.5,0,0,1,.5-.5h96.68a.5.5,0,0,1,.5.5v20.06A.5.5,0,0,1,188.05,140.66Zm-96.18-1h95.68V120.6H91.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,126.94h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,126.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,134.32h-2.52a.5.5,0,0,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,126.94h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,126.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,134.32h-2.52a.5.5,0,1,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,126.94h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,126.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,134.32h-2.52a.5.5,0,0,1,0-1H156a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,126.94h-2.53a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.53a.5.5,0,0,1,.5.5A.51.51,0,0,1,164.17,126.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,134.32h-2.53a.5.5,0,0,1,0-1h2.53a.5.5,0,1,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,126.94h-2.53a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.53a.5.5,0,0,1,.5.5A.51.51,0,0,1,172.32,126.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,134.32h-2.53a.5.5,0,0,1,0-1h2.53a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,126.94H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,126.94Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,134.32H178a.5.5,0,0,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 126.44,
    width: 30.35,
    height: 7.38,
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,134.32H97.3a.5.5,0,0,1-.5-.5v-7.38a.5.5,0,0,1,.5-.5h30.35a.5.5,0,0,1,.5.5v7.38A.5.5,0,0,1,127.65,134.32Zm-29.85-1h29.35v-6.38H97.8Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.83,
    cy: 130.21,
    r: 1.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.75,
    cy: 130.21,
    r: 1.92,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.37,
    y: 145.12,
    width: 96.69,
    height: 20.06,
    transform: "translate(279.42 310.31) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,165.68H91.37a.5.5,0,0,1-.5-.5V145.12a.5.5,0,0,1,.5-.5h96.68a.5.5,0,0,1,.5.5v20.06A.5.5,0,0,1,188.05,165.68Zm-96.18-1h95.68V145.62H91.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,152h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,152Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,159.34h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,159.34Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,152h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,152Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,159.34h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,159.34Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,152h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,152Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,159.34h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,159.34Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,152h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,164.17,152Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,159.34h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,164.17,159.34Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,152h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,172.32,152Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,159.34h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,172.32,159.34Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,152H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,152Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,159.34H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,159.34Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 151.46,
    width: 30.35,
    height: 7.38,
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,159.34H97.3a.5.5,0,0,1-.5-.5v-7.38a.5.5,0,0,1,.5-.5h30.35a.5.5,0,0,1,.5.5v7.38A.5.5,0,0,1,127.65,159.34Zm-29.85-1h29.35V152H97.8Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.83,
    cy: 155.23,
    r: 1.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.75,
    cy: 155.23,
    r: 1.92,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.37,
    y: 170.15,
    width: 96.69,
    height: 20.06,
    transform: "translate(279.42 360.36) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,190.71H91.37a.5.5,0,0,1-.5-.5V170.15a.5.5,0,0,1,.5-.5h96.68a.5.5,0,0,1,.5.5v20.06A.5.5,0,0,1,188.05,190.71Zm-96.18-1h95.68V170.65H91.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,177h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,177Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,184.37h-2.52a.5.5,0,0,1,0-1h2.52a.5.5,0,1,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,177h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,177Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,184.37h-2.52a.5.5,0,0,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,177h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,177Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,184.37h-2.52a.5.5,0,0,1,0-1H156a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,177h-2.53a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.53a.5.5,0,0,1,.5.5A.51.51,0,0,1,164.17,177Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,184.37h-2.53a.5.5,0,0,1,0-1h2.53a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,177h-2.53a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.53a.5.5,0,0,1,.5.5A.51.51,0,0,1,172.32,177Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,184.37h-2.53a.5.5,0,1,1,0-1h2.53a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,177H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,177Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,184.37H178a.5.5,0,0,1,0-1h2.52a.5.5,0,1,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 176.49,
    width: 30.35,
    height: 7.38,
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,184.37H97.3a.5.5,0,0,1-.5-.5v-7.38a.5.5,0,0,1,.5-.5h30.35a.5.5,0,0,1,.5.5v7.38A.5.5,0,0,1,127.65,184.37Zm-29.85-1h29.35V177H97.8Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.83,
    cy: 180.26,
    r: 1.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.75,
    cy: 180.26,
    r: 1.92,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.37,
    y: 195.17,
    width: 96.69,
    height: 20.06,
    transform: "translate(279.42 410.41) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.05,215.73H91.37a.5.5,0,0,1-.5-.5V195.17a.5.5,0,0,1,.5-.5h96.68a.5.5,0,0,1,.5.5v20.06A.5.5,0,0,1,188.05,215.73Zm-96.18-1h95.68V195.67H91.87Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,202h-2.52a.5.5,0,0,1,0-1h2.52a.5.5,0,1,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,209.39h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,139.71,209.39Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,202h-2.52a.5.5,0,0,1,0-1h2.52a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,209.39h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,147.86,209.39Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,202h-2.52a.5.5,0,0,1,0-1H156a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,209.39h-2.52a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H156a.5.5,0,0,1,.5.5A.5.5,0,0,1,156,209.39Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,202h-2.53a.5.5,0,0,1,0-1h2.53a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,209.39h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,164.17,209.39Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,202h-2.53a.5.5,0,1,1,0-1h2.53a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,209.39h-2.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h2.53a.51.51,0,0,1,.5.5A.5.5,0,0,1,172.32,209.39Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,202H178a.5.5,0,0,1,0-1h2.52a.5.5,0,1,1,0,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,209.39H178a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.52a.5.5,0,0,1,.5.5A.5.5,0,0,1,180.47,209.39Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 201.51,
    width: 30.35,
    height: 7.38,
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,209.39H97.3a.5.5,0,0,1-.5-.5v-7.38a.5.5,0,0,1,.5-.5h30.35a.5.5,0,0,1,.5.5v7.38A.5.5,0,0,1,127.65,209.39Zm-29.85-1h29.35V202H97.8Z",
    fill: "#ff663b",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.83,
    cy: 205.28,
    r: 1.92,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.75,
    cy: 205.28,
    r: 1.92,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.01,
    y: 159.47,
    width: 11.32,
    height: 87.79,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.33,247.75H237a.5.5,0,0,1-.5-.5V159.47a.5.5,0,0,1,.5-.5h11.32a.5.5,0,0,1,.5.5v87.78A.5.5,0,0,1,248.33,247.75Zm-10.82-1h10.32V160H237.51Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.33,
    y: 159.47,
    width: 11.32,
    height: 87.79,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.65,247.75H306.33a.5.5,0,0,1-.5-.5V159.47a.5.5,0,0,1,.5-.5h11.32a.5.5,0,0,1,.5.5v87.78A.5.5,0,0,1,317.65,247.75Zm-10.82-1h10.32V160H306.83Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.98,
    y: 166.05,
    width: 100.42,
    height: 30.14,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.4,196.69H226a.5.5,0,0,1-.5-.5V166.05a.5.5,0,0,1,.5-.5H326.4a.5.5,0,0,1,.5.5v30.14A.5.5,0,0,1,326.4,196.69Zm-99.92-1H325.9V166.55H226.48Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.26 196.19 246.86 196.19 227.83 166.05 243.23 166.05 262.26 196.19",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.26,196.69h-15.4a.5.5,0,0,1-.42-.23l-19-30.14a.52.52,0,0,1,0-.51.5.5,0,0,1,.44-.25h15.4a.48.48,0,0,1,.42.23l19,30.14a.5.5,0,0,1,0,.5A.51.51,0,0,1,262.26,196.69Zm-15.13-1h14.23L243,166.55H228.73Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.41 196.19 278 196.19 258.98 166.05 274.38 166.05 293.41 196.19",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.41,196.69H278a.5.5,0,0,1-.42-.23l-19-30.14a.52.52,0,0,1,0-.51.48.48,0,0,1,.43-.25h15.41a.48.48,0,0,1,.42.23l19,30.14a.5.5,0,0,1-.42.76Zm-15.13-1H292.5l-18.4-29.15H259.88Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.55 196.19 309.15 196.19 290.12 166.05 305.52 166.05 324.55 196.19",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.55,196.69h-15.4a.5.5,0,0,1-.42-.23l-19-30.14a.52.52,0,0,1,0-.51.5.5,0,0,1,.44-.25h15.4a.48.48,0,0,1,.42.23l19,30.14a.5.5,0,0,1,0,.5A.51.51,0,0,1,324.55,196.69Zm-15.13-1h14.23l-18.4-29.15H291Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.98,
    y: 208.18,
    width: 98.57,
    height: 9.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.55,218.43H226a.5.5,0,0,1-.5-.5v-9.75a.5.5,0,0,1,.5-.5h98.57a.5.5,0,0,1,.5.5v9.75A.5.5,0,0,1,324.55,218.43Zm-98.07-1h97.57v-8.75H226.48Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.83,
    y: 69.01,
    width: 96.72,
    height: 59.28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.55,128.79H227.83a.5.5,0,0,1-.5-.5V69a.5.5,0,0,1,.5-.5h96.72a.5.5,0,0,1,.5.5v59.28A.5.5,0,0,1,324.55,128.79Zm-96.22-1h95.72V69.51H228.33Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.42,94.06h2.66l1.19,6.57h0l1.19-6.57h2.66v9.17h-1.77V96.29h0L245,103.23h-1.56l-1.36-6.94h0v6.94h-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,94.06h2.53l1.93,9.17h-1.86l-.34-1.82v0h-2.12l-.34,1.79H249Zm2,6.13-.83-4.53h0l-.81,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.33,94.06h1.86v9.17h-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.58,94.06h2.34l1.81,5.49h0V94.06h1.66v9.17h-1.91l-2.24-6.69h0v6.69h-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.27,95.38h-1.95V94.06h5.76v1.32h-1.95v7.85h-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,94.06h5.08v1.32h-3.22V97.8h2.56v1.31h-2.56v2.81h3.22v1.31H273Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.13,94.06h2.34l1.81,5.49h0V94.06H285v9.17h-1.91l-2.24-6.69h0v6.69h-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.8,94.06h2.53l1.93,9.17h-1.87l-.34-1.82v0h-2.11l-.34,1.79h-1.73Zm2,6.13L289,95.66h0l-.81,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.15,94.06h2.34l1.81,5.49h0V94.06H299v9.17h-1.92l-2.23-6.69h0v6.69h-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,102.77a2,2,0,0,1-.7-1.66V96.19a2.06,2.06,0,0,1,.7-1.67,3.88,3.88,0,0,1,4.08,0,2.07,2.07,0,0,1,.71,1.67v1H304V96.1c0-.57-.31-.86-.93-.86s-.93.29-.93.86v5.11q0,.84.93.84t.93-.84v-1.4h1.77v1.3a2,2,0,0,1-.71,1.66,3.82,3.82,0,0,1-4.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.88,94.06H312v1.32h-3.22V97.8h2.56v1.31h-2.56v2.81H312v1.31h-5.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.39,
    y: 238.31,
    width: 106.64,
    height: 4.07,
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,242.88H86.39a.51.51,0,0,1-.5-.5v-4.07a.5.5,0,0,1,.5-.5H193a.5.5,0,0,1,.5.5v4.07A.51.51,0,0,1,193,242.88Zm-106.14-1H192.53V238.8H86.89Z",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataMaintenanceFlatline);
export default __webpack_public_path__ + "static/media/data-maintenance-flatline.2fb976a1391fe62aef5398d1428dbfd6.svg";
export { ForwardRef as ReactComponent };